import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { axiosRequest } from "../../api";
import { baseURL } from "../../constant";
import PageNotFound from "./404";

function CmsPage(){
    const { slug } = useParams();
    const [page, setPage] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadCmsPage = async () => {
            setLoading(true);
            setPage(null);

            try {
                const response = await axiosRequest.get(`${baseURL}/getCmsPage/${slug}`);
                const cmsPage = response.data && response.data.id ? response.data : null;
                setPage(cmsPage);

                if (cmsPage?.meta_title || cmsPage?.title) {
                    document.title = cmsPage.meta_title || cmsPage.title;
                }
            } catch (error) {
                setPage(null);
            } finally {
                setLoading(false);
            }
        };

        loadCmsPage();
    }, [slug]);

    if (!loading && !page) {
        return <PageNotFound />;
    }

    return(
        <>
          <section className="inner-page section-themebg">
              <div className="container">
                <div className="row">
                    <div className="col-12 text-center">
                        <h3>{page?.title || ""}</h3>
                    </div>
                </div>
              </div>
         </section>

         <section className="section-padding inner-content">
              <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-9 col-sm-12 col-12">
                        {loading && <p>Loading...</p>}
                        {!loading && page && (
                            <>
                                <h3>{page.title}</h3>
                                <div dangerouslySetInnerHTML={{ __html: page.description || "" }} />
                            </>
                        )}
                    </div>
                </div>
              </div>
         </section>
        </>
    );
}
export default CmsPage;
